<template>
    <section id="content" class="gray-area">
        <div class="container">
            <!-- >>> 'BreadCrumbs' - Row -->
            <div class="row">
                <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                <sdr-breadcrumbs active_item="second" :module="modulo"></sdr-breadcrumbs>
                <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
            </div>
            <!-- <<< 'BreadCrumbs' - Row -->

            <!-- >>> 'RebookingPassengers' - Row -->
            <div class="row">
                <div class="container shortcode travel-ideas">
                    <h1 class="idea-title" style="margin-bottom:30px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ headline_step1[getCurrentLocale] }}</h1>
                </div>


                <!-- >>> Left Side: 'Booking Details' -->
                <sdr-rebooking-bookingno-bookingdetails :modulo="modulo" mode="rebookingpassengers"></sdr-rebooking-bookingno-bookingdetails>
                <!-- <<< Left Side: 'Booking Details' -->


                <!-- >>>  Right Side: Sidebar, 'Passengers' -->
                <div class="sidebar col-sms-6 col-sm-4 col-md-3">
                    <!-- >>> VueCmp - 'sdr-shared-cart', 'Shared Cart' -->
                    <!-- <sdr-shared-cart :modulo="modulo"></sdr-shared-cart> -->
                    <!-- <<< VueCmp - 'sdr-shared-cart', 'Shared Cart' -->

                    <!-- >>> VueCmp - 'sdr-contact-box', 'Contact Box' -->
                    <sdr-contact-box></sdr-contact-box>
                    <!-- <<< VueCmp - 'sdr-contact-box', 'Contact Box' -->
                </div>
                <!-- <<<  Right Side: Sidebar, 'Passengers' -->
            </div>
            <!-- <<< 'RebookingPassengers' - Row -->
        </div>
    </section>
</template>

<script>
    import BookingDetails from '../pagecontent/BookingnoBookingDetails.vue';

    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue';

    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';
    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'], // via: router/push
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-rebooking-bookingno-bookingdetails': BookingDetails,
            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                headline_step1: {
                    en: 'Step 2: Select Passengers and Date for rebooking.',
                    de: 'Schritt 2: Passagiere und Datum zum umbuchen wählen.'
                },
                // >>> --------------------------
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),




        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([

            ]),

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4a6e89;
    }

    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.5em;
        }

        button.btn-large,
        input[type='button'].button.btn-large,
        a.button.btn-large {
            font-size: 1em;
        }
    }
</style>